/**
 * FE#204 — derive a PER-RECIPIENT clientIdempotencyKey when one scheduled
 * message fans out to multiple recipients.
 *
 * The compose dialog stamps ONE `clientIdempotencyKey` per dialog session (so a
 * double-click / no-feedback re-submit dedupes instead of creating twice). The
 * multi-recipient loop then created a separate usermessage per contact but
 * reused that single batch key for all of them. Because the backend enforces a
 * UNIQUE sparse index on `clientIdempotencyKey` (user-messages.model.ts), the
 * creates for recipients 2..N collided and were rejected — so only the first
 * group persisted.
 *
 * Suffixing the base key with the recipient id keeps each recipient's create
 * idempotent across re-submits (stable input → stable key) while making the N
 * keys distinct so all N recipients persist as separate items. Falls back to the
 * loop index when a recipient carries no id, so uniqueness always holds.
 */
export function derivePerRecipientIdempotencyKey(
  baseKey: string | undefined | null,
  contactId: string | undefined | null,
  index: number,
): string | undefined {
  if (!baseKey) return undefined; // nothing to make idempotent
  const suffix = contactId && String(contactId).trim() ? String(contactId) : String(index);
  return `${baseKey}:${suffix}`;
}
